export default __webpack_public_path__ + "static/media/particles-web-theme6.b1031732.svg";